import Image from "next/image";
import { blurDataURL } from "../../../utils/constants/images";

const NewsDetailHero = ({ thumbnail, title }) => {
  return (
    <>
      <section className="relative h-[100vh] w-full bg-gradient-to-t from-black ">
        <div
          className="w-full h-full absolute bg-gradient-to-b from-black via-black to-black opacity-[0.7]"
          aria-hidden="true"
        ></div>

        <div className="absolute h-full w-full object-cover sm:object-fill mix-blend-overlay">
          <Image
            src={thumbnail}
            fill="true"
            alt="News Thumbnail"
            quality={100}
            placeholder="blur"
            blurDataURL={blurDataURL}
            className="relative h-full w-full object-cover sm:object-fill"
          />
        </div>

        <div className="absolute flex flex-col space-y-2 md:space-y-4 lg:space-y-4 2xl:space-y-4 bottom-20 2xl:bottom-32 pl-8 pr-6 left-0 right-2 mb-24 md:mb-24 lg:mb-24 2xl:mb-32 2xl:pl-80">
          <h1 className="max-w-7xl mx-auto text-xl font-extrabold tracking-wide sm:tracking-normal sm:text-2xl lg:text-5xl 2xl:text-7xl text-white md:w-3/4 lg:w-3/4">
            {title}
          </h1>
        </div>

        <div className="flex flex-col justify-center items-center">
          <div className="absolute bottom-28 2xl:bottom-40 pl-8 max-w-7xl mx-auto animate-bounce">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 15l7-7 7 7"
              />
            </svg>
          </div>

          <span className="absolute bottom-24 2xl:bottom-32 pl-8 max-w-7xl mx-auto text-center text-xs font-normal text-gray-400">
            <span className="text-gray-400 sm:text-sm">Scroll To Read</span>
          </span>
        </div>
      </section>
    </>
  );
};

export default NewsDetailHero;
